import script from "./StepPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPayment.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__